import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Container,
  Input,
  Label,
  Row,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { Radio } from "antd";
import DatePicker from "react-datepicker";

import * as Yup from "yup";
//import images
import {
  COLOR_USER_TYPE_LOG,
  getPlatFormImage,
  LIST_OPTION_OS,
  LIST_OPTION_SOURCE_APP,
  MANUAL_PUSH_REDIRECT_SCREEN_TARGET,
  MANUAL_PUSH_SAVE_OPTION,
  MANUAL_PUSH_SEND_TIME_OPTION,
  USER_TYPE_LOG_OPTION,
} from "helpers/constans";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import PushNotificationApi from "api/pushNotificationApi";
import DropdownOptionImage from "components/Common/DropdownOptionImage";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import DropdownAsyncUsersNotification, { LabelUserOption } from "components/Common/DropdownAsyncUsersNotification";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import TooltipCustom from "components/Common/TooltipCustom";
import DropdownAsyncRegions from "components/Common/DropdownAsyncRegions";
import { Option } from "api/types/_public";

registerLocale("en", en);
registerLocale("ko", ko);
const DATA_REQUIRED_TARGETID = ["open-link", "bar", "wink", "news", "profile"];

const ManualPushForm = ({
  itemToEdit,
  setItemToEdit,
  loadTableData,
  triggerRefresh,
  onCloseClick,
}: any) => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  const MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG =
    MANUAL_PUSH_REDIRECT_SCREEN_TARGET?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    }));

  const LIST_OPTION_OS_LANG =
    LIST_OPTION_OS?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [appNameSearch, setAppNameSearch] = useState<any>("baive");
  const [listCheckedUsers, setListCheckedUsers] = useState<any>({ label: t("All Filter"), value: "all" });
  const [listCheckedRegion1, setListCheckedRegion1] = useState<any>([{ label: t("All Filter"), value: "all" }]);
  const [listCheckedRegion2, setListCheckedRegion2] = useState<any>(null);
  const [listCheckedRegion3, setListCheckedRegion3] = useState<any>(null);
  const [notify_action, setRedirectScreenTarget] = useState(
    MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG?.[0]?.value
  );
  const [isRequiredTargetId, setIsRequiredTargetId] = useState<boolean>(false);
  const [isTargetDeepLink, setIsTargetDeepLink] = useState<boolean>(false);
  const [isMultipleUser, setIsMultipleUser] = useState<boolean>(false);
  const [isMultipleRegion1, setIsMultipleRegion1] = useState<boolean>(false);
  const [isMultipleRegion2, setIsMultipleRegion2] = useState<boolean>(false);
  const [isMultipleRegion3, setIsMultipleRegion3] = useState<boolean>(false);

  const checkHasAllUser = (lstUsers: any) => {
    let allUser = null;
    if (lstUsers instanceof Array) {
      allUser = lstUsers?.find((e: any) => e?.value === "all");
    }

    return allUser;
  };

  const handleChangeSelectUsers = (event: any) => {
    const allUser = checkHasAllUser(event);

    if (allUser) {
      setListCheckedUsers([{ label: t("All Filter"), value: "all" }]);
    }
  };

  const resetSelectedUser = () => {
    setIsMultipleUser(false);
    setListCheckedUsers({
      label: t("All Filter"),
      value: "all",
    })
  }

  const handleChangeSelectOS = (e: any) => {
    if(e?.value === formik?.values?.device_os) return;

    formik.setFieldValue("device_os", e?.value);
    formik.setFieldValue("OS", e?.value);
    resetSelectedUser();
  };

  const handleChangeScreenTarget = (e: any) => {
    setIsRequiredTargetId(false);
    setIsTargetDeepLink(false);
    setRedirectScreenTarget(e?.value);
    formik.setFieldValue("notify_action", e?.value);

    if (DATA_REQUIRED_TARGETID.includes(e?.value)) {
      setIsRequiredTargetId(true);
    } else {
      formik.setFieldValue("targetId", "");
    }
    if (e.value === "open-link" || e.value === "profile") {
      setIsTargetDeepLink(true);
    }
  };

  const handleSelectAsyncUsers = (event: any) => {
    if(!event || event?.length === 0 || event?.value === 'all') {
      setIsMultipleUser(false);
      setListCheckedUsers({
        label: t("All Filter"),
        value: "all",
      })
    }else {
      setIsMultipleUser(checkHasAllUser(event) ? false : true);
      setListCheckedUsers(event);
      handleChangeSelectUsers(event);
    }
  };

  const checkIsAllEmpty = (event: any) => {
    if(!event || event?.length === 0 || event?.value === 'all' || checkHasAllUser(event)) return true;

    return false;
  }

  const handleSelectRegion = (event: any, type = "region1") => {
    switch (type) {
      case 'region1':
        if(checkIsAllEmpty(event)) {
          setIsMultipleRegion1(false)
          setListCheckedRegion1({
            label: t("All Filter"),
            value: "all",
          })
          setListCheckedRegion2(null);
          setListCheckedRegion3(null);
        }else {
          setIsMultipleRegion1(checkHasAllUser(event) ? false : true);
          setListCheckedRegion1(event);
        }
        break;
      case 'region2':
        if(checkIsAllEmpty(event)) {
          setIsMultipleRegion2(false)
          setListCheckedRegion2({
            label: t("All Filter"),
            value: "all",
          })
          setListCheckedRegion3(null);
        }else {
          setIsMultipleRegion2(checkHasAllUser(event) ? false : true);
          setListCheckedRegion2(event);
        }
        break;
      case 'region3':
        if(checkIsAllEmpty(event)) {
          setIsMultipleRegion3(false)
          setListCheckedRegion3({
            label: t("All Filter"),
            value: "all",
          })
        }else {
          setIsMultipleRegion3(checkHasAllUser(event) ? false : true);
          setListCheckedRegion3(event);
        }
        break;
    } 
  };

  const formatRegionParams = (data: any) => {
    if(data) {
      if(data?.value) {
        return data?.value;
      } else if(data?.length > 0) {
        return data?.map((item: Option) => (item?.value))?.join(',')
      }
    }
    return '';
  }

  const handleSubmit = async (values: any) => {
    setIsLoading(true);

    let formatListUsers: any = '';
    let target_users: any = '';
    if(listCheckedUsers?.value === 'all' || (listCheckedUsers?.length === 1 && checkHasAllUser(listCheckedUsers))) {
      formatListUsers = null;
    } else if(listCheckedUsers?.value) {
      formatListUsers = [listCheckedUsers?.value];
      target_users = [listCheckedUsers?.data];
    } else {
      formatListUsers = listCheckedUsers?.map((i: any) => i?.data?.id);
      target_users = listCheckedUsers?.map((i: any) => i?.data);
    }

    const formatedData = {
      device_type: values?.device_os || "all", // ios, android
      app_name: appNameSearch || "all", // baive_manager, baive
      date: formatDateStringToUTC(values?.date_send || new Date()), // UTC
      title: { ko: values?.title, en: values?.title }, // consider language keys: ko, en, ja, vi
      body: {
        ko: values?.content,
        en: values?.content,
      }, // consider language keys: ko, en, ja, vi
      redirect_type: values?.notify_action, // home, search, explore, chat, post-detail, open-link, bar, wink, profile, news, chat
      redirect_value: {
        target_id: values?.targetId,
        to_user_ids: formatListUsers,
        target_users: target_users
      },
      send_type: values?.send_type,
      user_type: values?.user_type ?? '',
      region1: formatRegionParams(listCheckedRegion1),
      region2: formatRegionParams(listCheckedRegion2),
      region3: formatRegionParams(listCheckedRegion3),
      save_option: values?.save_option ?? '0',
    };

    try {
      const response: any = itemToEdit?.id ? await PushNotificationApi.updateNotifications(
        itemToEdit?.id,
        formatedData
      ) : await PushNotificationApi.createNotifications(
        formatedData
      );

      if (response?.data) {
        setIsLoading((_prev) => false);
        resetFormSubmit();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        onCloseClick();
        triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        if (response.success == false) {
          toast(`${response?.message}`, CONFIG_OPTION_TOAST_ERROR);
        }
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const resetFormSubmit = () => {
    setAppNameSearch("");
    setListCheckedUsers(null);
    setIsTargetDeepLink(false);
    formik.resetForm();
    setRedirectScreenTarget(
      MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG?.[0]?.value
    );
    setIsRequiredTargetId(false);
  };

  const validationSchema = Yup.object({
    title: Yup.string().required(`${t("This field is required")}`),
    content: Yup.string().required(`${t("This field is required")}`),
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      content: "",
      date_send: null,
      OS: "",
      notify_action: MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG?.[0]?.value,
      userIds: [],
      targetId: "",
      send_type: 'immediately',
      user_type: "",
      app_name: "baive",
      device_os: "",
      save_option: 1
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if(itemToEdit) {

      if(itemToEdit?.target_value) {
        if (DATA_REQUIRED_TARGETID.includes(itemToEdit?.notify_action)) {
          setIsRequiredTargetId(true);
        } else {
          formik.setFieldValue("targetId", "");
        }
        if (itemToEdit?.notify_action === "open-link" || itemToEdit?.notify_action === "profile") {
          setIsTargetDeepLink(true);
        }
      }

      if(itemToEdit?.target_users?.length > 0) {
        const targetUsers = itemToEdit?.target_users;
        setIsMultipleUser(true);

        const formatOption = targetUsers?.map((user : any) => {
          return {
            data: user,
            value: user?.id,
            label: <LabelUserOption user={user} />
          }
        })
        setListCheckedUsers(formatOption)
      }
      
      formik.setValues({
        ...itemToEdit,
        content: itemToEdit?.body,
        targetId: itemToEdit?.target_value,
        user_type: itemToEdit?.user_type !== 'all' ? itemToEdit?.user_type : '',
        date_send: itemToEdit.date_send
          ? new Date(formatDateStringToKorea(itemToEdit.date_send))
          : null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemToEdit]);

  
  useEffect(() => {
    document.title = `${t("Send Push (Manual)")} - ${t(
      "Push Notification"
    )} | Dispatch`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Modal isOpen={true} centered={true} scrollable={false} size="xl">
        <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
          {t("Send Message")}
        </ModalHeader>
        <ModalBody className="py-3 px-4">
          <Container fluid className="px-0">
            <form onSubmit={formik.handleSubmit}>
              <Row>
                <Col lg={4}>
                  <div className="mb-3">
                    <Label className="form-label">{t("OS")}</Label>

                    <DropdownOptionImage
                      name="os"
                      dataList={LIST_OPTION_OS_LANG || []}
                      placeholder={`${t("OS")}...`}
                      className="dropdown-status-rounded"
                      classNamePrefix="name-prefix"
                      initialValue={formik?.values?.device_os || ""}
                      onChangeSelect={(e: any) => handleChangeSelectOS(e)}
                      isHasOptionAll={true}
                      optionAll={{
                        label: t("All Filter"),
                        value: "",
                      }}
                      isClearable={false}
                    />

                    {formik?.touched?.OS && formik?.errors?.OS ? (
                      <div className="text-danger mt-2">
                        {/* {formik?.errors?.OS} */}
                      </div>
                    ) : null}
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="mb-3">
                    <Label className="form-label">{t("App")}</Label>

                    <DropdownOptionNew
                      name="app_name"
                      dataList={LIST_OPTION_SOURCE_APP || []}
                      placeholder={`${t("Select App Name")}...`}
                      className="dropdown-status-rounded"
                      classNamePrefix="name-prefix"
                      initialValue={formik?.values?.app_name}
                      onChangeSelect={(e: any) => {
                        if(e?.value === formik?.values?.app_name) return;

                        setAppNameSearch(e?.value);
                        formik.setFieldValue("app_name", e?.value);
                        formik.setFieldValue("user_type", '');
                        resetSelectedUser();
                      }}
                      isHasOptionAll={true}
                      optionAll={{
                        label: t("All Filter"),
                        value: "",
                      }}
                      lstImage={true}
                      hideSelectedOptions={false}
                    />
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="mb-3">
                    <Label className="form-label">{t("User Type")}</Label>

                    <DropdownStatusNew
                      name="type-user"
                      dataList={
                        (formik?.values?.app_name == "baive" && [
                          USER_TYPE_LOG_OPTION[0],
                          USER_TYPE_LOG_OPTION[1],
                        ]) ||
                        (formik?.values?.app_name == "baive_manager" && [
                          USER_TYPE_LOG_OPTION[2],
                          USER_TYPE_LOG_OPTION[3],
                        ]) ||
                        USER_TYPE_LOG_OPTION ||
                        []
                      }
                      placeholder={`${t("Select user type")}...`}
                      className="dropdown-status-rounded"
                      classNamePrefix="name-prefix"
                      initialValue={String(formik?.values?.user_type) || ""}
                      onChangeSelect={(e: any) => {
                        if(e?.value === formik?.values?.user_type) return;

                        formik.setFieldValue("user_type", e?.value);
                        resetSelectedUser();
                      }}
                      isHasOptionAll={true}
                      optionAll={{ label: t("All Filter"), value: "" }}
                      colors={COLOR_USER_TYPE_LOG}
                    />
                  </div>
                </Col>

                <Col lg={12}>
                  <Row className="position-relative mb-2" style={{border: "1px dashed #009ef7", borderRadius: 5, margin: 0, paddingTop: 20}} >
                    <div className="position-absolute bg-white w-auto text-primary" style={{top: -10, left: 10, padding: "0 5px"}}>{t('Region')}</div>
                    <Col lg={4}>
                      <div className="mb-3">
                        <Label className="form-label">{t("Province/Metropolitan City")}</Label>

                        <DropdownAsyncRegions
                          name="manual-push-users"
                          onChangeSelect={(e) => {
                            handleSelectRegion(e, 'region1');
                            resetSelectedUser();
                          }}
                          isMulti={isMultipleRegion1}
                          placeholder={`${t("Select province/metropolitan city")}...`}
                          isShowIconCheck={true}
                          listChecked={listCheckedRegion1}
                          hideSelectedOptions={false}
                          defaultParams={{
                            region1: 'all',
                          }}
                          isAllOption={true}
                          keyRegion={"region1"}
                          key={`list-region1`}
                          isClearable={false}
                        />
                      </div>
                    </Col>

                    <Col lg={4}>
                      <div className="mb-3">
                        <Label className="form-label">{t("City/District")}</Label>

                        <DropdownAsyncRegions
                          name="manual-push-users"
                          onChangeSelect={(e) => {
                            handleSelectRegion(e, 'region2');
                            resetSelectedUser();
                          }}
                          isMulti={isMultipleRegion2}
                          placeholder={`${t("Select city/district")}...`}
                          isShowIconCheck={true}
                          listChecked={listCheckedRegion2}
                          hideSelectedOptions={false}
                          defaultParams={{
                            region1: formatRegionParams(listCheckedRegion1),
                          }}
                          keyRegion={"region2"}
                          isAllOption={true}
                          key={`list-${formatRegionParams(listCheckedRegion1)}`}
                          isClearable={false}
                          isDisabled={(formatRegionParams(listCheckedRegion1) !== 'all') ? false : true}
                        />
                      </div>
                    </Col>

                    <Col lg={4}>
                      <div className="mb-3">
                        <Label className="form-label">{t("Town/Neighborhood")}</Label>

                        <DropdownAsyncRegions
                          name="manual-push-users"
                          onChangeSelect={(e) => {
                            handleSelectRegion(e, 'region3');
                            resetSelectedUser();
                          }}
                          isMulti={isMultipleRegion3}
                          placeholder={`${t("Select town/neighborhood")}...`}
                          isShowIconCheck={true}
                          listChecked={listCheckedRegion3}
                          hideSelectedOptions={false}
                          defaultParams={{
                            region1: formatRegionParams(listCheckedRegion1),
                            region2: formatRegionParams(listCheckedRegion2),
                          }}
                          keyRegion={"region3"}
                          isAllOption={true}
                          key={`list-${formatRegionParams(listCheckedRegion1)}-${formatRegionParams(listCheckedRegion2)}`}
                          isDisabled={(formatRegionParams(listCheckedRegion1) !== 'all' && formatRegionParams(listCheckedRegion2) !== 'all') ? false : true}
                          isClearable={false}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <Label className="form-label">{t("User")}</Label>

                    <DropdownAsyncUsersNotification
                      name="manual-push-users"
                      onChangeSelect={(handleSelectAsyncUsers)}
                      isMulti={isMultipleUser}
                      placeholder={`${t("Select User")}...`}
                      isShowIconCheck={true}
                      listCheckedUsers={listCheckedUsers}
                      hideSelectedOptions={false}
                      defaultParams={{
                        os: formik?.values?.device_os,
                        app_name: appNameSearch,
                        user_type: formik?.values?.user_type,
                        region1: formatRegionParams(listCheckedRegion1),
                        region2: formatRegionParams(listCheckedRegion2),
                        region3: formatRegionParams(listCheckedRegion3),
                      }}
                      isShowOnManualPush={true}
                      isAllOption={true}
                      key={`list-${formik?.values?.device_os}-${appNameSearch}-${formik?.values?.user_type}-${formatRegionParams(listCheckedRegion1)}-${formatRegionParams(listCheckedRegion2)}-${formatRegionParams(listCheckedRegion3)}`}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Label className="form-label">
                      {t("Open Type")}{" "}
                      <span className="text-danger"> *</span>
                    </Label>

                    <DropdownOptionNew
                      name="notify_action"
                      dataList={MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG || []}
                      placeholder={`${t("Open Type")}...`}
                      className="dropdown-status-rounded"
                      classNamePrefix="name-prefix"
                      initialValue={formik?.values?.notify_action || null}
                      onChangeSelect={(e: any) => handleChangeScreenTarget(e)}
                      isHasOptionAll={false}
                      hideSelectedOptions={false}
                      optionAll={{
                        label: t("All Filter"),
                        value: "",
                      }}
                      isClearable={false}
                    />

                    {formik?.touched?.notify_action &&
                    formik?.errors?.notify_action ? (
                      <div className="text-danger mt-2">
                        {formik?.errors?.notify_action as any}
                      </div>
                    ) : null}
                  </div>
                </Col>

                {
                  isRequiredTargetId && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label htmlFor="titleInput" className="form-label">
                          {t(isTargetDeepLink ? "Target Deep Link" : "Target ID")}
                          {
                              !isTargetDeepLink && <TooltipCustom
                                title={`${t('Enter the ID of the target location to navigate to.')} <br/> ${t('Example: Entering a Bar ID will navigate to the corresponding bar.')}`}
                                className="d-inline-block vertical-align-middle ms-1 thumbnail-mt"
                                style={{ transform: 'translateY(2px)' }}
                              >
                                <i className="ri-question-line align-bottom text-secondary" ></i>
                              </TooltipCustom>
                          }
                        </Label>
                        <Input
                          name="targetId"
                          type="text"
                          className="form-control"
                          id="targetId"
                          placeholder={t(
                            isTargetDeepLink
                              ? "Enter Your Target Deep Link"
                              : "Enter target ID"
                          )}
                          value={formik?.values?.targetId}
                          onChange={(event: any) => {
                            formik.setFieldValue("targetId", event?.target?.value);
                            formik.setFieldValue("targetDeepLink", "");
                          }}
                          disabled={!isRequiredTargetId}
                        />
                        {formik?.touched?.targetId && formik?.errors?.targetId ? (
                          <div className="text-danger mt-2">
                            {formik?.errors?.targetId}
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  )
                }
                
                <Col lg={12}>
                  <div className="mb-3">
                    <Label htmlFor="titleInput" className="form-label">
                      {t("Title")} <span className="text-danger">*</span>
                    </Label>
                    <Input
                      name="title.en"
                      type="text"
                      className="form-control"
                      id="titleInput"
                      placeholder={t("Enter notification title")}
                      value={formik?.values?.title}
                      onChange={(event: any) => {
                        formik.setFieldValue("title", event?.target?.value);
                      }}
                    />
                    {formik?.touched?.title && formik?.errors?.title ? (
                      <div className="text-danger mt-2">
                        {formik?.errors?.title}
                      </div>
                    ) : null}
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="mb-3">
                    <Label htmlFor="titleKoreaInput" className="form-label">
                      {t("Content")} <span className="text-danger"> *</span>
                    </Label>
                    <textarea
                      className="form-control"
                      id="content"
                      name="content"
                      value={formik?.values?.content}
                      placeholder={`${t("Enter notification content")}...`}
                      onChange={(event: any) => {
                        formik.setFieldValue(
                          "content",
                          event?.target?.value || ""
                        );
                      }}
                      style={{ height: 80 }}
                    />
                    {formik.touched.content && formik.errors.content ? (
                      <div className="text-danger mt-2">
                        {formik.errors.content}
                      </div>
                    ) : null}
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <Label htmlFor="titleKoreaInput" className="form-label">
                      {t("Send Time")}
                    </Label>
                    <div>
                      <Radio.Group
                        onChange={(e) => {
                          formik.setFieldValue("send_type", e?.target?.value);
                        }}
                        value={formik?.values?.send_type}
                        disabled={!!itemToEdit?.id}
                      >
                        {
                          MANUAL_PUSH_SEND_TIME_OPTION?.map((item) => {
                            return <Radio value={item?.value} key={item?.value}>{t(item?.label)}</Radio>;
                          })
                        }
                      </Radio.Group>
                      
                      {formik?.values?.send_type === "schedule" && (
                        <span className="w-100 mt-2">
                          <DatePicker
                            name={"start_date"}
                            className="form-control"
                            selected={formik?.values?.date_send ?? null}
                            placeholderText={t("Select sending time")}
                            onChange={(date: any) => {
                              formik.setFieldValue("date_send", date);
                            }}
                            dateFormat="yyyy-MM-dd HH:mm:ss"
                            isClearable={true}
                            showTimeSelect
                          />
                        </span>
                      )}

                      {/* {formik.touched.start_date && formik.errors.start_date ? (
                        <div className="text-danger mt-2">
                       {formik.errors.start_date} 
                        </div>
                      ) : null} */}
                    </div>
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <Label htmlFor="titleKoreaInput" className="form-label">
                      {t("Save Notification")}
                    </Label>
                    <div>
                      <Radio.Group
                        onChange={(e) => {
                          formik.setFieldValue("save_option", e?.target?.value);
                        }}
                        value={formik?.values?.save_option}
                        disabled={!!itemToEdit?.id}
                      >
                        {
                          MANUAL_PUSH_SAVE_OPTION?.map((item) => {
                            return <Radio value={item?.value} key={item?.value}>{t(item?.label)}</Radio>;
                          })
                        }
                      </Radio.Group>
                    </div>
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="hstack gap-2 justify-content-end mt-4">
                    <button
                      className="btn btn-primary fs-14"
                      color="success"
                      type="submit"
                      disabled={isLoading}
                      style={{ width: "140px" }}
                    >
                      {isLoading ? (
                        <Spinner size="sm" className="me-2"></Spinner>
                      ) : (
                        <>{t("Send")}</>
                      )}
                    </button>
                  </div>
                </Col>
              </Row>
            </form>
          </Container>

          <ToastContainer closeButton={false} limit={1} />
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ManualPushForm;
